import moment from "moment-timezone";
import { ButtonVisibility } from "./constants";
import { ConnectionButtonVisibilityState } from "./Interfaces";

function convertToUtcDateTime(
  dateString: string,
  timeString: string,
  timeZone: string
) {
  // Ensure moment-timezone is loaded
  console.log(dateString, timeString, timeZone, "--------9");

  // Remove the GMT part from the date string if it exists
  const cleanDateString = String(dateString)
    .replace(/GMT.*$/, "")
    .trim();

  // Parse the date string using moment with the provided timeZone
  const localDate = moment.tz(
    cleanDateString,
    "ddd MMM DD YYYY HH:mm:ss",
    timeZone
  );

  // Parse the time string in 12-hour format with AM/PM
  const timeParts = moment(timeString, "hh:mm A");

  // Apply the parsed time to the date
  localDate
    .hours(timeParts.hours())
    .minutes(timeParts.minutes())
    .seconds(timeParts.seconds());

  // Convert the local time to UTC
  const utcDateTime = localDate.utc();

  // Format the UTC date time
  const formattedUtcDateTime = utcDateTime.format("YYYY-MM-DD HH:mm:ss");

  return formattedUtcDateTime;
}

function getCurrentDateTimeInUtc(timeZone: string) {
  // Get the current date and time in the specified timezone
  const localDateTime = moment.tz(timeZone);

  // Convert the local date and time to a UTC moment object
  const utcDateTime = localDateTime.clone().utc();

  // Format the UTC date time
  const formattedUtcDateTime = utcDateTime.format("YYYY-MM-DD HH:mm:ss");

  return formattedUtcDateTime;
}

function validatePhoneNumber(phoneNumber: string) {
  const sanitizedPhoneNumber = phoneNumber.replace(/\D/g, "");

  const phoneNumberPattern = /^\d+$/;
  return phoneNumberPattern.test(sanitizedPhoneNumber);
}

function convertUtcToLocal(utcTime: string, timeZone: string) {
  const options: Intl.DateTimeFormatOptions = {
    timeZone,
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  return new Date(utcTime).toLocaleString("en-US", options);
}



function convertUtcToSystemTimeZone(utcTime: string) {
  const options: Intl.DateTimeFormatOptions = {
    hour12: false,
    year: "numeric",
    month: "2-digit",
    day: "2-digit",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Convert UTC string to Date object (interpreted as UTC)
  const date = new Date(utcTime);

  // Use system's local timezone automatically
  return date.toLocaleString("en-US", options);
}

const getDayOfWeek = (inputDateStr: string, format = "short") => {
  const inputDate = new Date(inputDateStr);
  const daysOfWeekShort = ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"];
  const daysOfWeekLong = [
    "Sunday",
    "Monday",
    "Tuesday",
    "Wednesday",
    "Thursday",
    "Friday",
    "Saturday",
  ];

  if (format === "short") {
    return daysOfWeekShort[inputDate.getDay()];
  } else {
    return daysOfWeekLong[inputDate.getDay()];
  }
};

const getMonthAndDay = (inputDateStr: string) => {
  const inputDate = new Date(inputDateStr);
  const months = [
    "Jan",
    "Feb",
    "Mar",
    "Apr",
    "May",
    "Jun",
    "Jul",
    "Aug",
    "Sep",
    "Oct",
    "Nov",
    "Dec",
  ];
  const month = months[inputDate.getMonth()];
  const day = inputDate.getDate();
  return `${month} ${day}`;
};

const getTime = (inputDateStr: string) => {
  const inputDate = new Date(inputDateStr);
  let hours = inputDate.getHours();
  const minutes = inputDate.getMinutes();
  const ampm = hours >= 12 ? "PM" : "AM";
  hours = hours % 12 || 12;
  return `${hours}:${minutes < 10 ? "0" : ""}${minutes} ${ampm}`;
};

function formatLocalDateForEndTime(originalDate: any, timezone: string) {
  let formattedDate = moment(originalDate).tz(timezone).format("MMM D, YYYY");
  let formattedTime = moment(originalDate).tz(timezone).format("hh:mm A");

  let combined =
    formattedDate + " at " + formattedTime + " " + timezone + " " + "Time zone";
  return combined;
}

function formatLocalDateForStartTime(originalDate: any, timezone: string) {
  let formattedDate = moment(originalDate).tz(timezone).format("MMM D, Y");
  let formattedTime = moment(originalDate).tz(timezone).format("hh:mm A");

  let combined = formattedDate + " at " + formattedTime;
  return combined;
}

function getDateTimeFromString(dateTimeStr: any) {
  const date = new Date(dateTimeStr);
  const year = date.getFullYear();
  const month = date.getMonth() < 10 ? `0${date.getMonth()}` : date.getMonth();
  const day = date.getDate() < 10 ? `0${date.getDate()}` : date.getDate();
  const hours = date.getUTCHours();
  const minutes = date.getUTCMinutes();
  return `${year}-${month}-${day} ${hours}:${minutes}:00`;
}

function convertToUTC(dateString: string, timeZone: string) {
  // Define the input format and timezone
  const inputFormat = "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ";
  // India Standard Time

  // Parse the input date string using moment-timezone
  const momentDate = moment.tz(dateString, inputFormat, timeZone);

  // Check if the parsed date is valid
  if (!momentDate.isValid()) {
    throw new Error("Invalid date string format.");
  }

  // Convert the date to UTC and format it as required
  const utcDateString = momentDate.utc().format("YYYY-MM-DD HH:mm:ss");

  return utcDateString;
}

function utcToLocalDate(utcTime: string, timeZone: string) {
  const localDateTime = moment.utc(utcTime).tz(timeZone);
  const formattedDate = localDateTime.format(
    "ddd MMM DD YYYY HH:mm:ss [GMT]ZZ"
  );
  console.log(formattedDate, timeZone, "----------149");
  return formattedDate;
}

function utcToLocalTime(utcTime: string, timeZone: string): string {
  const options: Intl.DateTimeFormatOptions = {
    timeZone,
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
    hour12: false,
  };

  const time = new Date(utcTime).toLocaleTimeString("en-US", options);
  return time;
}

function decodeBase64(s: string) {
  // Decode the base64 string

  const data = atob(s);

  return data;
}

function extractMonth(dateString: string): string | null {
  const dateParts = dateString.split(" ");
  if (dateParts.length < 5) return null;

  const monthName = dateParts[1];
  return monthName;
}

function extractDate(dateString: string): number | null {
  const dateParts = dateString.split(" ");
  if (dateParts.length < 5) return null;

  const day = parseInt(dateParts[2], 10);
  return day;
}

const replaceProfessionalWithNetworking = (str: string) => {
  return str?.replace("Professional", "Networking");
};

const formatPhoneNumber = (phoneNumber: string): string => {
  // Remove all non-numeric characters
  const cleaned = phoneNumber ? phoneNumber.replace(/\D/g, "") : "";
  // Ensure it has 11 digits and starts with +1
  // if (cleaned.length !== 11 || !cleaned.startsWith("1")) {
  //   return "Invalid phone number";
  // }
  // Format into +1 (XXX)-XXX-XXXX
  // return cleaned.replace(/(\d{1})(\d{3})(\d{3})(\d{4})/, "+$1 ($2)-$3-$4");
  return phoneNumber;
};

const getDateFormat = (groupDate: string) => {
  const formattedDate = moment(groupDate).format("Do MMM");
  return formattedDate;
};

const convertUTCToTimezoneDate = (
  eventDate: string,
  timezone: string,
  format?: string
) => {
  return moment
    .utc(eventDate)
    .tz(timezone)
    .format(format ? format : "YYYY-MM-DD HH:mm:ss");
};

const convertTimezoneDateToUTC = (
  eventDate: string,
  timezone: string,
  format?: string
) => {
  return moment
    .tz(eventDate, timezone)
    .utc()
    .format(format ? format : "YYYY-MM-DD HH:mm:ss");
};

const getConnectionButtonVisibilityState = (
  currentUserData: any,
  secondaryUserData: any
): ConnectionButtonVisibilityState | undefined => {
  const myPreferences = replaceProfessionalWithNetworking(
    currentUserData?.userProfileResponse?.meetingPurpose
  );
  const otherUserPreferences = replaceProfessionalWithNetworking(
    secondaryUserData?.userProfileResponse?.meetingPurpose
  );

  if (!myPreferences || !otherUserPreferences) {
    return undefined;
  }

  const isMutualMatch = isMutualGenderPreferencesMatched(
    currentUserData,
    secondaryUserData
  );

  const visibilityState: ConnectionButtonVisibilityState = {
    datingButtonVisibility: ButtonVisibility.Hidden,
    friendshipButtonVisibility: ButtonVisibility.Hidden,
    openToAnyButtonVisibility: ButtonVisibility.Hidden,
  };

  if (
    myPreferences.includes("Open to anything") &&
    otherUserPreferences.includes("Open to anything")
  ) {
    console.log("Here the open to anything actuon");
    visibilityState.datingButtonVisibility = isMutualMatch
      ? ButtonVisibility.Visible
      : ButtonVisibility.Hidden;
    visibilityState.friendshipButtonVisibility = ButtonVisibility.Visible;
    visibilityState.openToAnyButtonVisibility = isMutualMatch
      ? ButtonVisibility.Visible
      : ButtonVisibility.Hidden;
  } else if (myPreferences.includes("Open to anything")) {
    if (otherUserPreferences.includes("Dating")) {
      visibilityState.datingButtonVisibility = isMutualMatch
        ? ButtonVisibility.Visible
        : ButtonVisibility.Hidden;
    }
    if (
      otherUserPreferences.includes("Friendship") ||
      otherUserPreferences.includes("Networking")
    ) {
      visibilityState.friendshipButtonVisibility = ButtonVisibility.Visible;
    }
  } else if (otherUserPreferences.includes("Open to anything")) {
    if (myPreferences.includes("Dating")) {
      visibilityState.datingButtonVisibility = isMutualMatch
        ? ButtonVisibility.Visible
        : ButtonVisibility.Hidden;
    }
    if (
      myPreferences.includes("Friendship") ||
      myPreferences.includes("Networking")
    ) {
      visibilityState.friendshipButtonVisibility = ButtonVisibility.Visible;
    }
  } else {
    // Handle other cases as per original logic
    if (
      myPreferences.trim() === "Dating" &&
      otherUserPreferences.trim() === "Dating"
    ) {
      visibilityState.datingButtonVisibility = isMutualMatch
        ? ButtonVisibility.Visible
        : ButtonVisibility.Hidden;
    } else {
      const hasMutualFriendshipOrNetworking =
        (myPreferences.includes("Friendship") &&
          otherUserPreferences.includes("Friendship")) ||
        (myPreferences.includes("Networking") &&
          otherUserPreferences.includes("Networking")) ||
        (myPreferences.includes("Friendship") &&
          otherUserPreferences.includes("Networking")) ||
        (myPreferences.includes("Networking") &&
          otherUserPreferences.includes("Friendship"));

      if (hasMutualFriendshipOrNetworking) {
        visibilityState.friendshipButtonVisibility = ButtonVisibility.Visible;
      }

      if (
        myPreferences.includes("Dating") &&
        otherUserPreferences.includes("Dating")
      ) {
        visibilityState.datingButtonVisibility = isMutualMatch
          ? ButtonVisibility.Visible
          : ButtonVisibility.Hidden;
      }
    }
  }
  if (
    visibilityState.datingButtonVisibility === ButtonVisibility.Hidden &&
    visibilityState.friendshipButtonVisibility === ButtonVisibility.Hidden &&
    visibilityState.openToAnyButtonVisibility === ButtonVisibility.Hidden
  ) {
    return undefined;
  }
  return visibilityState;
};

const isMutualGenderPreferencesMatched = (
  currentUser: any,
  secondaryUser: any
): boolean => {
  if (!currentUser || !secondaryUser) return false;

  const currentUserGenderInterest = (
    currentUser?.userProfileResponse?.interestedIns || ""
  ).split(",");
  const secondaryUserGenderInterest = (
    secondaryUser?.userProfileResponse?.interestedIns || ""
  ).split(",");
  const currentUserGender = currentUser?.userProfileResponse?.gender
    ?.trim()
    ?.toUpperCase();
  const secondaryUserGender = secondaryUser?.userProfileResponse?.gender
    ?.trim()
    ?.toUpperCase();

  const currentUserPreferenceMatched = currentUserGenderInterest
    .map((interest: any) => interest.trim().toUpperCase())
    .includes(secondaryUserGender);

  const secondaryUserPreferenceMatched = secondaryUserGenderInterest
    .map((interest: any) => interest.trim().toUpperCase())
    .includes(currentUserGender);

  return currentUserPreferenceMatched && secondaryUserPreferenceMatched;
};

const compressImageToUnder1MB = (
  blob: Blob,
  maxSizeInBytes = 1 * 1024 * 1024
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(blob);

    img.onload = () => {
      const canvas = document.createElement("canvas");
      canvas.width = img.width;
      canvas.height = img.height;

      const ctx = canvas.getContext("2d");
      if (!ctx) return reject("Canvas context not found");

      ctx.drawImage(img, 0, 0);

      // Try different quality levels to get under 1MB
      const tryCompress = (quality: number) => {
        canvas.toBlob(
          (compressedBlob) => {
            if (!compressedBlob) return reject("Compression failed");
            if (compressedBlob.size <= maxSizeInBytes || quality < 0.1) {
              resolve(compressedBlob);
            } else {
              tryCompress(quality - 0.1); // Reduce quality step-by-step
            }
          },
          "image/jpeg",
          quality
        );
      };

      tryCompress(0.9); // Start at high quality
      URL.revokeObjectURL(url);
    };

    img.onerror = reject;
    img.src = url;
  });
};

const compressImageToHD = (
  blob: Blob,
  maxSizeInBytes = 1 * 1024 * 1024, // 1MB
  maxWidth = 1920,
  maxHeight = 1080
): Promise<Blob> => {
  return new Promise((resolve, reject) => {
    const img = new Image();
    const url = URL.createObjectURL(blob);

    img.onload = () => {
      let { width, height } = img;

      // Resize to fit within maxWidth x maxHeight while maintaining aspect ratio
      const ratio = Math.min(maxWidth / width, maxHeight / height, 1);
      const targetWidth = Math.round(width * ratio);
      const targetHeight = Math.round(height * ratio);

      const canvas = document.createElement("canvas");
      canvas.width = targetWidth;
      canvas.height = targetHeight;

      const ctx = canvas.getContext("2d");
      if (!ctx) {
        URL.revokeObjectURL(url);
        return reject("Canvas context not found");
      }

      ctx.drawImage(img, 0, 0, targetWidth, targetHeight);

      const tryCompress = (quality: number) => {
        canvas.toBlob(
          (compressedBlob) => {
            if (!compressedBlob) {
              URL.revokeObjectURL(url);
              return reject("Compression failed");
            }

            if (compressedBlob.size <= maxSizeInBytes || quality < 0.1) {
              URL.revokeObjectURL(url);
              resolve(compressedBlob);
            } else {
              tryCompress(quality - 0.05); // Reduce quality gradually
            }
          },
          "image/jpeg",
          quality
        );
      };

      tryCompress(0.92); // Start at high quality
    };

    img.onerror = () => {
      URL.revokeObjectURL(url);
      reject("Failed to load image");
    };

    img.src = url;
  });
};

const isIOS = () => {
  return (
    /iPad|iPhone|iPod/.test(navigator.userAgent) && !(window as any).MSStream
  );
};

const isSameDay = (start: string | Date, end: string | Date) => {
  const startDate = new Date(start);
  const endDate = new Date(end);
  return (
    startDate.getFullYear() === endDate.getFullYear() &&
    startDate.getMonth() === endDate.getMonth() &&
    startDate.getDate() === endDate.getDate()
  );
};
const removeQueryParam = (urlString: string, param: string) => {
  const url = new URL(urlString);
  url.searchParams.delete(param);
  return url.toString();
};

const removeQueryParams = (url: string, keys: string[]) => {
  const [baseUrl, queryString] = url.split("?");
  if (!queryString) return url;

  const params = new URLSearchParams(queryString);
  keys.forEach((key) => params.delete(key));

  const newQuery = params.toString();
  return newQuery ? `${baseUrl}?${newQuery}` : baseUrl;
};

const isSaleActive = (ticket: any): boolean => {
  if (!ticket?.isActive) return false; // check ticket active flag

  const nowUTC = new Date().toISOString();
  const start = new Date(ticket.saleStartTime).getTime();
  const end = new Date(ticket.saleEndTime).getTime();
  const now = new Date(nowUTC).getTime();

  return now >= start && now <= end;
};

const uniqueMobileContacts = (contactList: any) => {
  return contactList.filter(
    (contact: any, index: number, self: any) =>
      index ===
      self.findIndex(
        (c:any) =>
          (c.phone_no || "").replace(/\D/g, "") ===
          (contact.phone_no || "").replace(/\D/g, "")
      )
  );
};

const uniqueEmailContacts = (contactList: any[]) => {
  return contactList.filter(
    (contact, index, self) =>
      index ===
      self.findIndex(
        (c:any) =>
          (c.email || "").trim().toLowerCase() ===
          (contact.email || "").trim().toLowerCase()
      )
  );
};

const getBannerSize = () => {
  const raw = process.env.REACT_APP_EVENT_BANNER_WIDTH_HEIGHT;

  // Fallback values
  const DEFAULT_WIDTH = 1080;
  const DEFAULT_HEIGHT = 1350;

  if (!raw) {
    return { width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT };
  }

  const [w, h] = raw.split("*").map(Number);

  if (!w || !h || isNaN(w) || isNaN(h)) {
    console.warn(
      "Invalid REACT_APP_EVENT_BANNER_WIDTH_HEIGHT. Using defaults."
    );
    return { width: DEFAULT_WIDTH, height: DEFAULT_HEIGHT };
  }

  return { width: w, height: h };
};

const formatDateTime = (date: string, timeZone?: string) => {
  return new Date(date).toLocaleString(timeZone, {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};


const formatUtcToLocal = (utcDate: string) => {
  return new Date(utcDate).toLocaleString("en-US", {
    month: "short",
    day: "2-digit",
    year: "numeric",
    hour: "numeric",
    minute: "2-digit",
    hour12: true,
  });
};

export {
  validatePhoneNumber,
  convertUtcToLocal,
  getDayOfWeek,
  getMonthAndDay,
  getTime,
  convertToUtcDateTime,
  formatLocalDateForEndTime,
  formatLocalDateForStartTime,
  getDateTimeFromString,
  getCurrentDateTimeInUtc,
  convertToUTC,
  utcToLocalDate,
  utcToLocalTime,
  decodeBase64,
  extractMonth,
  extractDate,
  replaceProfessionalWithNetworking,
  formatPhoneNumber,
  getDateFormat,
  convertUTCToTimezoneDate,
  convertTimezoneDateToUTC,
  getConnectionButtonVisibilityState,
  compressImageToUnder1MB,
  isIOS,
  isSameDay,
  removeQueryParam,
  removeQueryParams,
  compressImageToHD,
  isSaleActive,
  uniqueMobileContacts,
  uniqueEmailContacts,
  convertUtcToSystemTimeZone,
  getBannerSize,
  formatDateTime,
  formatUtcToLocal
};
